import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "./LoginHistoryPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

const PAGE_SIZE = 30;

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const formatTime = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const formatInputDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toISOString().split("T")[0];
};

export default function LoginHistoryPage() {

  const [loginHistory, setLoginHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [dateFilter, setDateFilter] = useState("");

  const [page, setPage] = useState(1);

  const fetchLoginHistory = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/login-history`);

      if (res.data.success) {
        setLoginHistory(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch login history:", err.message);
    }
  };

  useEffect(() => {
    fetchLoginHistory();

    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer);

  }, []);

  /* FILTER + SEARCH */

  const filteredLogs = useMemo(() => {

    return loginHistory.filter((log) => {

      const matchesSearch =
        log.fullname.toLowerCase().includes(search.toLowerCase()) ||
        log.email.toLowerCase().includes(search.toLowerCase());

      const matchesDate =
        !dateFilter ||
        formatInputDate(log.loginTime) === dateFilter;

      return matchesSearch && matchesDate;

    });

  }, [loginHistory, search, dateFilter]);

  /* PAGINATION */

  const totalPages = Math.ceil(filteredLogs.length / PAGE_SIZE);

  const paginatedData = filteredLogs.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  return (
    <div className="login-history-page">

      <h1 className="login-history-title">
        System Login History
      </h1>

      {/* FILTER BAR */}

      <div className="login-history-filters">

        <input
          className="login-search-input"
          placeholder="Search by Full Name or Email"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />

        <input
          type="date"
          className="login-date-filter"
          value={dateFilter}
          onChange={(e) => {
            setDateFilter(e.target.value);
            setPage(1);
          }}
        />

      </div>

      <div className="login-history-table-card">

        {loading ? (
          <div className="login-history-loading">
            Loading login records...
          </div>
        ) : (

          <>

            <table className="login-history-table">

              <thead>
                <tr>
                  <th>SN</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th>System Role</th>
                  <th>IP Address</th>
                  <th>Login Date</th>
                  <th>Login Time</th>
                </tr>
              </thead>

              <tbody>

                {paginatedData.map((log, index) => (

                  <tr key={log._id}>

                    <td>{(page - 1) * PAGE_SIZE + index + 1}</td>

                    <td>{log.fullname}</td>

                    <td>{log.email}</td>

                    <td>
                      <span className="role-badge">
                        {log.systemRole}
                      </span>
                    </td>

                    <td>{log.ipAddress}</td>

                    <td>{formatDate(log.loginTime)}</td>

                    <td>{formatTime(log.loginTime)}</td>

                  </tr>

                ))}

              </tbody>

            </table>

            {/* PAGINATION */}

            <div className="login-pagination">

              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              >
                Previous
              </button>

              <span>
                Page {page} of {totalPages || 1}
              </span>

              <button
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              >
                Next
              </button>

            </div>

          </>

        )}

      </div>

    </div>
  );
}